const BaseService = require('@/services/BaseService')

const login = (email, password, cb, errorCb) => {
  BaseService.post('login', {email: email, password: password}, cb, errorCb)
}

export {
  login
}


// WEBPACK FOOTER //
// ./src/services/auth/AuthService.js